// FILE 19: src/components/catalog/CategoryFilter.js
import React from 'react';
import { CATEGORY_LIST } from '../../data/categories';
import './CategoryFilter.css';

/**
 * @param {string}   activeCategory  - currently selected category key
 * @param {function} onSelect        - called with category key string
 */
export default function CategoryFilter({ activeCategory, onSelect }) {
  return (
    <nav className="category-filter" aria-label="Category filter">
      <ul className="category-filter__list">
        {CATEGORY_LIST.map(({ key, label }) => (
          <li key={key}>
            <button
              className={`category-filter__pill${activeCategory === key ? ' category-filter__pill--active' : ''}`}
              onClick={() => onSelect(key)}
              aria-pressed={activeCategory === key}
            >
              {label}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
}
